module.exports = __webpack_public_path__ + "static/media/circle-border-green.d2ae3a86.svg";